import { Card, CardContent, Typography, Box, Stack, Chip, LinearProgress, CircularProgress } from "@mui/material";
import { colors, roleColors } from "../../../ui/colors";
import { SUPER_LIGHT_BORDER } from "./PersonalInformation";

export const QuickStats = ({ completionRate, availabilityCount, servicesCount, memberSince, sx }) => {
  return (
    <Card elevation={0} sx={{ borderRadius: 3, border: `1px solid ${SUPER_LIGHT_BORDER}`, ...(sx || {}) }}>
      <CardContent>
        <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
          Quick Stats
        </Typography>

        <Stack spacing={1} paddingY={1}>
          <Box sx={{ textAlign: "center", mb: 2 }}>
            <Box sx={{ mt: 3, position: "relative", display: "inline-flex", alignItems: "center", justifyContent: "center" }}>
              <svg
                width="160"
                height="160"
                viewBox="0 0 100 100"
                style={{
                  position: "absolute",
                  top: "55%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  pointerEvents: "none",
                }}
              >
                <path id="completionCurve" fill="transparent" d="M 10,50 A 40,40 0 0,1 90,50" />
                <text style={{ fontSize: "7px", fontWeight: 800, fill: "var(--fx-surface-texttertiary, #94A3B8)", letterSpacing: "1.5px" }}>
                  <textPath xlinkHref="#completionCurve" startOffset="50%" textAnchor="middle">
                    COMPLETION RATE
                  </textPath>
                </text>
              </svg>

              {/* Círculo de fondo */}
              <CircularProgress variant="determinate" sx={{ color: colors.gray[100] }} size={100} thickness={5} value={100} />

              {/* Círculo de progreso real */}
              <CircularProgress
                variant="determinate"
                value={completionRate}
                size={100}
                thickness={5}
                sx={{
                  color: completionRate > 80 ? roleColors.residential[500] : "#FFB347",
                  position: "absolute",
                  left: 0,
                  [`& .MuiCircularProgress-circle`]: {
                    strokeLinecap: "round",
                  },
                }}
              />

              {/* Porcentaje al centro */}
              <Box sx={{ position: "absolute" }}>
                <Typography variant="h5" sx={{ fontWeight: 800, color: "text.primary" }}>
                  {`${Math.round(completionRate)}%`}
                </Typography>
              </Box>
            </Box>
          </Box>

          <Box sx={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
            <Typography
              variant="caption"
              sx={{
                display: "block",
                color: "var(--fx-surface-texttertiary, #94A3B8)",
                fontWeight: 600,
                textTransform: "uppercase",
                fontSize: "0.68rem",
                mb: 0.25,
              }}
            >
              Available Days
            </Typography>
            <Chip
              size="small"
              label={`${availabilityCount}/21 slots`}
              sx={{
                borderRadius: "8px",
                fontWeight: 500,
                bgcolor: availabilityCount > 10 ? roleColors.residential[100] : "var(--fx-colors-warning-50, #FFF7ED)",
                color: availabilityCount > 10 ? roleColors.residential[700] : colors.orange.base,
              }}
            />
          </Box>

          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Typography
              variant="caption"
              sx={{
                display: "block",
                color: "var(--fx-surface-texttertiary, #94A3B8)",
                fontWeight: 600,
                textTransform: "uppercase",
                fontSize: "0.68rem",
                mb: 0.25,
              }}
            >
              Services
            </Typography>
            <Typography variant="caption" sx={{ fontWeight: 600 }}>
              {servicesCount}
            </Typography>
          </Box>

          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Typography
              variant="caption"
              sx={{
                display: "block",
                color: "var(--fx-surface-texttertiary, #94A3B8)",
                fontWeight: 600,
                textTransform: "uppercase",
                fontSize: "0.68rem",
                mb: 0.25,
              }}
            >
              Member Since
            </Typography>
            <Typography variant="caption" sx={{ fontWeight: 600 }}>
              {memberSince}
            </Typography>
          </Box>
        </Stack>
      </CardContent>
    </Card>
  );
};
